/* eslint-disable react-hooks/exhaustive-deps */
import { ErrorMessage, Field } from 'formik';
import { Col, Form, FormControl, Row } from 'react-bootstrap';
import { FormLabel, FormStepHeader } from '../../../../../components/forms';
import Editor from '../../../../../components/editor/Editor';
import { StepProps } from './AddEditSnippet';

export const SnippetForm = ({ touched, errors, readOnly }: StepProps) => {
  return (
    <>
      <Row>
        <Col xs={12}>
          <FormStepHeader title="Snippet Details" showRequiredLegend={!readOnly} />
        </Col>
        <Col
          xs={12}
          lg={6}
          className="pe-1"
        >
          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="name"
          >
            <FormLabel required>Name</FormLabel>
            <Field
              name="name"
              as={Form.Control}
              isInvalid={touched.name && !!errors.name}
              aria-required
            />
            <ErrorMessage name="name">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>
          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="content"
          >
            <FormLabel required>Content</FormLabel>
            <Field
              name="content"
              component={Editor}
              isInvalid={touched.content && !!errors.content}
              aria-required
            />
            <ErrorMessage name="content">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>
        </Col>
      </Row>
    </>
  );
};
